import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickAccessCard = ({ title, description, icon, route, progress, stats }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(route)}
      className="card text-left w-full hover:shadow-warm-md transition-base group"
    >
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex-1 min-w-0">
          <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-base">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>
        <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary group-hover:scale-110 transition-base">
          <Icon name={icon} size={24} className="text-primary group-hover:text-primary-foreground transition-base" />
        </div>
      </div>
      {progress !== undefined && (
        <div className="mb-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-muted-foreground">Overall Progress</span>
            <span className="text-sm font-semibold text-foreground">{progress}%</span>
          </div>
          <div className="character-progress h-2">
            <div 
              className="character-progress-bar" 
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      )}
      {stats && stats?.length > 0 && (
        <div className="grid grid-cols-2 gap-3">
          {stats?.map((stat, index) => (
            <div key={index} className="flex items-center gap-2">
              <Icon name={stat?.icon} size={16} className="text-muted-foreground" />
              <div>
                <div className="text-lg md:text-xl font-bold text-foreground">{stat?.value}</div>
                <div className="text-xs text-muted-foreground">{stat?.label}</div>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="flex items-center gap-2 mt-4 text-sm font-medium text-primary group-hover:gap-3 transition-base">
        View Details
        <Icon name="ArrowRight" size={16} />
      </div>
    </button>
  );
};

export default QuickAccessCard;